// extracted by mini-css-extract-plugin
export default {"top":"style_top__tQfY1","profile":"style_profile__tkUU7","image":"style_image__nztVe","name":"style_name__vo+L2","Shouts":"style_Shouts__b0RYb"};